import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import axios from "axios";
import { URL_API_CONFIGURACION } from "constantes/urls";

function AlertDb() {
  const [content, setContent] = useState({
    title: "",
    textParagraph: "",
  });

  const [isOpen, setIsOpen] = useState(false);

  const getStatusAlertAndConfiguration = async () => {
    try {
      const response = await axios.get(
        `${URL_API_CONFIGURACION}/alerta-mensaje-portal`
      );

      if (response) {
        if (response.status === 200) {
          setContent({
            title: response.data.title ?? "Mensaje importante",
            textParagraph: response.data.message ?? "",
          });
          setIsOpen(response.data.isOpen);
        }
      }
    } catch (error) {
      console.log(error.stack);
    }
  };

  useEffect(() => {
    (async () => {
      await getStatusAlertAndConfiguration();
    })();
  }, []);

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogContent>
        <Alert severity="info">
          <Typography component="h1" variant="h5">
            <strong>{content.title}</strong>
          </Typography>
          {content.textParagraph ? (
            <Typography component="p" variant="body2">
              {content.textParagraph}
            </Typography>
          ) : (
            'No hay un mensaje, de clic en el botón "Aceptar"'
          )}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Grid container justify="center">
          <Grid item xs={10} sm={10} md={3} lg={3}>
            <Button
              color="primary"
              variant="contained"
              fullWidth
              onClick={() => setIsOpen(false)}
            >
              Aceptar
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

export default AlertDb;
